<template>
  <div>
    <Head title="湖南省小额贷款公司经营数据填报系统" />
    <portal-target name="dropdown" slim />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="md:flex md:flex-shrink-0" style="height: 64px;">
          <div
            class="md:text-md flex items-center justify-between p-4 w-full text-lg bg-white border-b md:px-8 md:py-0"
          >
            <div class="flex items-center justify-between">
              <Link :href="zroute('app.dashboard')"><i class="bi-grid-3x3-gap-fill hover:bg-gray-200" /></Link>
              <div class="ml-2">xxx</div>
            </div>
            <div class="justify-between">
              <el-tooltip v-if="auth.user.is_admin" class="item" effect="dark" content="通讯录" placement="bottom">
                <Link class="mr-2" :href="zroute('contacts.index')"><i class="el-icon-notebook-1" /></Link>
              </el-tooltip>
              <dropdown class="mt-1" placement="bottom-end">
                <template #default>
                  <div class="group flex items-center cursor-pointer select-none">
                    <div class="mr-1 text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 whitespace-nowrap">
                      <span>{{ auth.user.nickname }}</span>
                    </div>
                    <icon
                      class="w-5 h-5 fill-gray-700 group-hover:fill-indigo-600 focus:fill-indigo-600"
                      name="cheveron-down"
                    />
                  </div>
                </template>
                <template #dropdown>
                  <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                    <div
                      class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500"
                    >
                      修改密码
                    </div>
                    <Link
                      class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" href="/logout"
                      method="delete" as="button"
                    >
                      退出登录
                    </Link>
                  </div>
                </template>
              </dropdown>
            </div>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <slot />
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :show-close="false" :visible.sync="visible" title="密码修改">
      <el-form ref="form" :model="form" :rules="rules" class="m-4">
        <el-form-item label="旧密码" prop="old_password">
          <el-input v-model="form.old_password" type="password" show-password auto-complete="new-password" />
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="form.password" type="password" show-password auto-complete="new-password" />
        </el-form-item>
        <el-form-item label="重复密码" prop="password_confirmation">
          <el-input v-model="form.password_confirmation" type="password" show-password auto-complete="new-password" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="submitForm">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import axios from 'axios'
import zroute from '../ziggy'

export default {
  components: {
    Dropdown,
    Icon,
    Link,
    Head,
  },
  props: {
    auth: Object,
  },
  data() {
    return {
      visible: this.auth.user.is_new === 1,
      loading: false,
      form: {
        old_password: '',
        password: '',
        password_confirmation: '',
      },
      rules: {
        old_password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { required: true, validator: (rule, value, callback) => {
            if (value === this.form.old_password) {
              callback(new Error('新密码不能和旧密码相同'))
            } else {
              callback()
            }
          }, trigger: 'blur' },
        ],
        password_confirmation: [
          { required: true, message: '请重复输入新密码', trigger: 'blur' },
          { required: true, validator: (rule, value, callback) => {
            if (value !== this.form.password) {
              callback(new Error('两次输入的密码不一致'))
            } else {
              callback()
            }
          }, trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          axios.post(zroute('modify_password'), this.form).then((res) => {
            this.loading = false
            if (res.data.code === 0) {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
  },
}
</script>
